import { Controller } from '@hotwired/stimulus'
import { disableScroll, enableScroll } from '../utils/global'

// Управляет статическим окном OAuth-входа из layout. Контроллер расположен на
// body, чтобы одна кнопка в header могла открыть dialog в конце документа.
export default class LoginModalController extends Controller {
  static targets = ['dialog']

  connect() {
    this.trigger = null
    this.scrollLocked = false
  }

  disconnect() {
    if (this.scrollLocked) enableScroll()
  }

  open(event) {
    event.preventDefault()
    if (!this.hasDialogTarget || this.dialogTarget.open) return

    this.trigger = event.currentTarget
    this.dialogTarget.showModal()
    disableScroll()
    this.scrollLocked = true
  }

  close(event) {
    event?.preventDefault()
    if (!this.hasDialogTarget || !this.dialogTarget.open) return

    this.dialogTarget.close()
    this.unlockScroll()
    this.trigger?.focus()
  }

  closeOnBackdrop(event) {
    // У native dialog клик по backdrop приходит на сам dialog.
    if (event.target === this.dialogTarget) this.close(event)
  }

  openCookiePolicy(event) {
    event.preventDefault()
    this.close()
    window.CookieConsent?.showPreferences()
  }

  unlockScroll() {
    if (!this.scrollLocked) return

    enableScroll()
    this.scrollLocked = false
  }
}
